import { createFileRoute } from "@tanstack/react-router";
import { NewLeadPage } from "@/features/new-lead/new-lead-page";

export const Route = createFileRoute("/_authenticated/$store/opportunities/new")({
  head: () => ({ meta: [{ title: "Add lead · Rogue AI" }] }),
  component: NewLeadPage,
});
